import React from 'react';
import { CodeHistory } from '@yandex-int/k-common';
import { useCodingProblemProps } from '../context';

import { CodingBlocklyEditor } from '../__blockly-code-editor/coding-problem__blocky-code-editor';
import { CodingCodeEditor } from '../__code-editor/coding-problem__code-editor';

type CodingEditorProps = {
    view?: 'mobile';
    initialValue: () => string | CodeHistory;
    sessionKey: string;
};

export function CodingEditor({ view, initialValue, sessionKey }: CodingEditorProps) {
    const props = useCodingProblemProps();
    const language = props.problem.markup.languages[0];

    if (language.language === 'python_blockly') {
        return <CodingBlocklyEditor />;
    }
    return <CodingCodeEditor initialValue={initialValue} sessionKey={sessionKey} view={view} />;
}
